function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M 24.66 34.446 C 29.793 34.446 33.885 30.281 33.885 25.223 C 33.885 20.165 29.718 16 24.66 16 C 19.601 16 15.435 20.09 15.435 25.223 C 15.435 30.355 19.601 34.446 24.66 34.446 Z M 24.66 19.272 C 27.933 19.272 30.537 21.951 30.537 25.148 C 30.537 28.347 27.859 31.025 24.66 31.025 C 21.386 31.025 18.783 28.347 18.783 25.148 C 18.783 21.951 21.386 19.272 24.66 19.272 Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M 24.66 36.752 C 19.304 36.752 14.17 38.909 10.227 42.925 C 9.558 43.595 9.558 44.636 10.227 45.306 C 10.525 45.604 10.971 45.827 11.418 45.827 C 11.864 45.827 12.31 45.677 12.608 45.306 C 15.881 41.959 20.196 40.099 24.66 40.099 C 29.049 40.099 33.364 41.959 36.711 45.306 C 37.381 45.975 38.422 45.975 39.092 45.306 C 39.762 44.636 39.762 43.595 39.092 42.925 C 35.149 38.983 30.016 36.752 24.66 36.752 Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M 43.631 34.446 C 46.606 34.446 49.061 31.992 49.061 29.017 C 49.061 26.041 46.606 23.587 43.631 23.587 C 40.654 23.587 38.2 26.041 38.2 29.017 C 38.125 31.992 40.581 34.446 43.631 34.446 Z M 43.631 26.859 C 44.82 26.859 45.713 27.826 45.713 28.942 C 45.713 30.132 44.747 31.025 43.631 31.025 C 42.515 31.025 41.547 30.058 41.547 28.942 C 41.473 27.826 42.44 26.859 43.631 26.859 Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M 54.195 40.992 C 50.252 37.347 44.82 35.859 39.39 37.272 C 38.497 37.496 37.977 38.388 38.2 39.281 C 38.422 40.174 39.39 40.694 40.208 40.471 C 44.523 39.355 48.838 40.471 51.888 43.372 C 52.186 43.67 52.632 43.818 53.004 43.818 C 53.45 43.818 53.897 43.67 54.195 43.298 C 54.938 42.702 54.864 41.661 54.195 40.992 Z"
});

function SvgParentsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#FFFF",
    id: "lni_lni-users",
    x: "0px",
    y: "0px",
    viewBox: "1.036 0 62.739 62.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(236, 117, 0)",
      strokeWidth: 0
    },
    cx: 32.303,
    cy: 31.115,
    rx: 30.5,
    ry: 30.5
  }), _ref2, _ref3, _ref4, _ref5));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentsLogo);
export default __webpack_public_path__ + "static/media/parents-logo.e637b946.svg";
export { ForwardRef as ReactComponent };